import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/general/tevo-label.png'
import _imports_1 from '@/assets/general/product-inverter-square-white.png'
import _imports_2 from '@/assets/general/product-battery-square-white.png'
import _imports_3 from '@/assets/general/product-solar-panels-square-white.png'


const _withScopeId = n => (_pushScopeId("data-v-9c3f1d90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = {
  key: 0,
  class: "tevo-label img-fluid",
  src: _imports_0,
  alt: "Proudly backed by Tevo, the makers of Magneto LED Lantern"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "d-flex h-100 flex-column justify-content-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h1 text-uppercase m-0 mb-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "A brighter future,"),
  /*#__PURE__*/_createTextVNode(" where the power belongs to you!")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Magneto Renewable Energy supplies market-leading green energy products, tailored to deliver a reduction in energy costs and carbon footprint to home owners, commercial and industrial businesses. Our expertise in sourcing, logistics and route-to-market, ensures highly competitive pricing and industry-leading speed of delivery.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Our comprehensive systems include solar panels, energy management devices, energy storage devices, and a network of installation expertise, alleviating the need for multiple suppliers.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "With a well-established logistics chain, we are able to stock, manage and distribute our high-quality products throughout South Africa.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Customisable solutions tailored to your unique energy needs.")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary-residential" }, "Learn more about us", -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"container text-center my-5\" data-v-9c3f1d90><div data-v-9c3f1d90><h2 class=\"h1 pt-3\" data-v-9c3f1d90>What do you need for <b data-v-9c3f1d90>energy independence?</b></h2><p data-v-9c3f1d90> Energy independence in your home is easy with the right components. All you need is an <b data-v-9c3f1d90>inverter, battery,</b> and <b data-v-9c3f1d90>solar panels.</b><br data-v-9c3f1d90><b data-v-9c3f1d90>The inverter</b> converts the energy from the solar panels into electricity that can be used in your home. <b data-v-9c3f1d90>The battery</b> stores energy for later use, so you can have power even when the sun is not shining. Finally, <b data-v-9c3f1d90>the solar panels</b> capture the sun&#39;s energy and convert it into electricity that can be used in your home. </p><p data-v-9c3f1d90>With these three components, you can easily become energy independent and reduce your reliance on the grid.</p></div><div class=\"row justify-content-evenly energy-independence\" data-v-9c3f1d90><div class=\"col-12 col-md-4 col-lg-3\" data-v-9c3f1d90><div class=\"rounded rounded-circle bg-secondary-residential d-inline-flex justify-content-center align-item-center mt-5 mb-4\" data-v-9c3f1d90><img class=\"img-fluid btn-close-white\" src=\"" + _imports_1 + "\" alt=\"Inverter unit diagram\" data-v-9c3f1d90></div><h3 class=\"h4\" data-v-9c3f1d90><b data-v-9c3f1d90>An inverter</b></h3></div><div class=\"col-12 col-md-4 col-lg-3\" data-v-9c3f1d90><div class=\"rounded rounded-circle bg-secondary-residential d-inline-flex justify-content-center align-item-center mt-5 mb-4\" data-v-9c3f1d90><img class=\"img-fluid btn-close-white\" src=\"" + _imports_2 + "\" alt=\"Battery unit diagram\" data-v-9c3f1d90></div><h3 class=\"h4\" data-v-9c3f1d90><b data-v-9c3f1d90>A battery</b></h3></div><div class=\"col-12 col-md-4 col-lg-3\" data-v-9c3f1d90><div class=\"rounded rounded-circle bg-secondary-residential d-inline-flex justify-content-center align-item-center mt-5 mb-4\" data-v-9c3f1d90><img class=\"img-fluid btn-close-white\" src=\"" + _imports_3 + "\" alt=\"Solar panel unit diagram\" data-v-9c3f1d90></div><h3 class=\"h4\" data-v-9c3f1d90><b data-v-9c3f1d90>Solar panels</b></h3></div><div class=\"col-12\" data-v-9c3f1d90><hr class=\"border border-1 mt-5 mb-0 mb-md-3\" data-v-9c3f1d90></div></div></div>", 1)
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container text-center my-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", { class: "h1" }, [
      /*#__PURE__*/_createElementVNode("b", null, "How"),
      /*#__PURE__*/_createTextVNode(" does solar work?")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "Solar energy works by using solar panels to collect and convert the sun's energy into electricity. The solar panels are typically mounted on the roof and absorb the sun's rays. The panels then convert the sunlight into direct current (DC) electricity. The DC electricity is then sent to an inverter, which converts the DC electricity into alternating current (AC) electricity. This AC electricity can then be used to power your home's electrical system, just like any other electrical source."),
    /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mt-5" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-11 col-lg-8 col-xxl-9" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-16x9" }, [
          /*#__PURE__*/_createElementVNode("iframe", {
            src: "https://www.youtube.com/embed/2Kwb5wLwQlk?rel=0",
            allowfullscreen: ""
          })
        ])
      ])
    ])
  ])
], -1))
const _hoisted_14 = { class: "container text-center my-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h1 pt-3" }, [
    /*#__PURE__*/_createTextVNode("Our "),
    /*#__PURE__*/_createElementVNode("b", null, "power solutions")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "3 Customisable renewable energy solutions for you to choose from:")
], -1))
const _hoisted_16 = { class: "row justify-content-center power-solution-cards mt-4 mb-5" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-11 col-lg-8 col-xxl-9" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ratio ratio-16x9" }, [
      /*#__PURE__*/_createElementVNode("iframe", {
        src: "https://www.youtube.com/embed/AhzcQnAC8Jg?rel=0",
        allowfullscreen: ""
      })
    ])
  ])
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CarouselBanner = _resolveComponent("CarouselBanner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InfoSection = _resolveComponent("InfoSection")!
  const _component_PowerSolutionBlock = _resolveComponent("PowerSolutionBlock")!
  const _component_SolarSignupLinkBanner = _resolveComponent("SolarSignupLinkBanner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showTevoLabel)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(_component_CarouselBanner, {
        uniqueId: "homeBanner",
        images: _ctx.homeBannerImages
      }, null, 8, ["images"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_InfoSection, {
        class: "my-5 text-center text-lg-start",
        imageSrc: _ctx.introSection.imageSrc,
        imageAlt: _ctx.introSection.imageAlt,
        imageLocation: _ctx.introSection.imageLocation,
        hideImageMobile: _ctx.introSection.hideImageMobile,
        textAlign: _ctx.introSection.textAlign
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createVNode(_component_router_link, {
              class: "text-decoration-none",
              to: { name: 'ResidentialAboutUs' }
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["imageSrc", "imageAlt", "imageLocation", "hideImageMobile", "textAlign"])
    ]),
    _hoisted_12,
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_PowerSolutionBlock, {
          displayNumber: "1",
          title: "Medium",
          kilowattsHybrid: "5",
          kilowattsLithium: "5",
          url: { name: 'ResidentialSolution', params: { slug: 'medium' } }
        }),
        _createVNode(_component_PowerSolutionBlock, {
          displayNumber: "2",
          title: "Large",
          kilowattsHybrid: "8",
          kilowattsLithium: "10",
          url: { name: 'ResidentialSolution', params: { slug: 'large' } }
        }),
        _createVNode(_component_PowerSolutionBlock, {
          displayNumber: "3",
          title: "X Large",
          kilowattsHybrid: "12",
          kilowattsLithium: "10",
          url: { name: 'ResidentialSolution', params: { slug: 'x-large' } }
        })
      ]),
      _hoisted_17
    ]),
    _hoisted_18,
    _createVNode(_component_SolarSignupLinkBanner)
  ]))
}